import {html, LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import {chNavStyles} from "@/components/ch-nav/ch-nav.style";


@customElement('sbk-ch-nav')
export class SbkChNav extends LitElement {


    static get styles() {
        return chNavStyles;
    }

    render() {
        return html`
        <div class="container">
            <slot></slot>
        </div>
        `;
    }
}
